import axiosAuth from '../../axiosMain';

async function index() {
  try {
    let response = await axiosAuth.get('/questions');
    return response.data.data;
  } catch (e) {}
}

async function store(data) {
  let response = await axiosAuth.post('/questions', data);
  return response.data.data;
}

async function show(questionId) {
  let response = await axiosAuth.get(`/questions/${questionId}`);
  return response.data.data;
}

async function update(data, id) {
  let response = await axiosAuth.patch('/questions/' + id, data);
  return response.data.data;
}

async function destroy(id) {
  let response = await axiosAuth.delete('/questions/' + id);
  return response.data.data;
}

export default {
  index,
  show,
  store,
  update,
  destroy,
};
